import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { CLINICS } from '../../constant';

interface Payload {
  key: string;
  options: string[];
}

export const createDropdownSettingApi = createAsyncThunk(
  'dropdownSettings/create',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        body: JSON.stringify(payload),
      };

      const res = await fetch(CLINICS.DROPDOWN_SETTINGS_URL, requestOptions);

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        return rejectWithValue(errorData.msg || 'Failed to create dropdown');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
